var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlSubstanesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1506 1.7H0V2.38H6.1506C6.31312 3.3432 7.15088 4.08 8.16 4.08C9.16912 4.08 10.0065 3.3432 10.1694 2.38H16.32V1.7H10.1694C10.0069 0.7367 9.16912 0 8.16 0C7.15088 0 6.31346 0.7367 6.1506 1.7ZM9.52 2.04C9.52 2.79 8.91004 3.4 8.16 3.4C7.40996 3.4 6.8 2.79 6.8 2.04C6.8 1.2899 7.40996 0.68 8.16 0.68C8.91004 0.68 9.52 1.2899 9.52 2.04Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.6202H2.4106C2.57346 15.5834 3.41122 16.3202 4.42 16.3202C5.42878 16.3202 6.26654 15.5834 6.4294 14.6202H16.32V13.9402H6.4294C6.26688 12.977 5.42912 12.2402 4.42 12.2402C3.41088 12.2402 2.57346 12.977 2.4106 13.9402H0V14.6202ZM4.42 12.9202C5.17004 12.9202 5.78 13.5302 5.78 14.2802C5.78 15.0302 5.17004 15.6402 4.42 15.6402C3.66996 15.6402 3.06 15.0302 3.06 14.2802C3.06 13.5302 3.66996 12.9202 4.42 12.9202Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.50009H10.2306C10.3931 9.46331 11.2309 10.2001 12.24 10.2001C13.2491 10.2001 14.0865 9.46331 14.2494 8.50009H16.32V7.82009H14.2494C14.0869 6.85687 13.2491 6.12011 12.24 6.12011C11.2309 6.12011 10.3935 6.85687 10.2306 7.82009H0V8.50009ZM12.24 6.80009C12.99 6.80009 13.6 7.41005 13.6 8.16009C13.6 8.91013 12.99 9.52009 12.24 9.52009C11.49 9.52009 10.88 8.91013 10.88 8.16009C10.88 7.41005 11.49 6.80009 12.24 6.80009Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlSubstanesIcon);
export default __webpack_public_path__ + "static/media/ControlSubstanesIcon.4040bbd9e32ebf7e28a39b35de2401ad.svg";
export { ForwardRef as ReactComponent };